<template>
    <main-layout>

        <app-header icon="factory">
            Détenteur
        </app-header>

        <action-bar :back="{ name: 'liste-detenteurs' }">
            <router-link v-if="typeUser === 'technicien'" class="btn add btn-full" id="main-action"
                :to="{ name: 'new-fibsdd', query: { detenteur: this.$route.params.id } }">
                <i class="icon-add"></i>
                <strong>Intervenir</strong> chez le détenteur
            </router-link>
        </action-bar>


        <div class="btn btn-full get-position" @click="getPosition()">
            <i class="icon-geoloc"></i>
        </div>

        <form method="post" id="detenteur" class="wrap" @submit.prevent="sendForm">
            <h2>Informations générales</h2>

            <label>Type</label>
            <select v-model="detenteur.type">
                <option disabled>Sélectionnez un type de détenteur</option>
                <option>Société</option>
                <option>Particulier</option>
                <option>Association</option>
            </select>

            <label>Raison sociale / Nom *</label>
            <input title="company" name="raison_sociale" id="raison_sociale" type="text"
                v-model.trim="detenteur.raison_sociale" readonly>

            <label>Code client</label>
            <input title="clientCode" name="code_client" id="code_client" type="text"
                v-model.trim="detenteur.code_client">

            <label v-show="detenteur.type !== 'Particulier'">SIRET</label>
            <cleave ref="siret" :options="siretOpt" v-model.trim="detenteur.siret"
                v-show="detenteur.type !== 'Particulier'"></cleave>

            <label>Adresse *</label>
            <input title="address" name="adresse" id="adresse" type="text" value="" v-model.trim="detenteur.adresse"
                maxlength="255">

            <label>Complément d'adresse</label>
            <input title="moreAddress" name="complement_adresse" id="complement_adresse" type="text" value=""
                v-model.trim="detenteur.complement_adresse" maxlength="255">

            <label>Code postal *</label>
            <cleave ref="cp" :options="cpOpt" v-model.trim="detenteur.code_postal"></cleave>

            <label>Ville *</label>
            <input title="city" name="adresse_ville" id="adresse_ville" type="text" value=""
                v-model.trim="detenteur.ville" maxlength="255">

            <label>Téléphone</label>
            <cleave ref="telephone" :options="telOpt" v-model.trim="detenteur.telephone" inputmode="tel"></cleave>

            <label>Email (adresse où seront envoyées les fiches)</label>
            <input title="email" name="email" id="email" type="text" v-model.trim="detenteur.email" maxlength="255">

            <h2>Contact</h2>

            <label>Nom / Prenom</label>
            <input title="fullName" name="nom_contact" id="nom_contact" type="text" v-model.trim="detenteur.nom"
                maxlength="255">

            <label>Téléphone portable</label>
            <cleave ref="portable" :options="telOpt" v-model.trim="detenteur.portable" inputmode="tel"></cleave>

            <label>Ligne directe</label>
            <cleave ref="lignedirecte" :options="telOpt" v-model.trim="detenteur.direct" inputmode="tel"></cleave>

            <label>Référence interne</label>
            <input title="ref" name="custom" id="custom" type="text" v-model.trim="detenteur.custom" readonly>

            <input v-if="canEditDetenteurs" type="submit" name="update" value="SAUVEGARDER">
        </form>
    </main-layout>
</template>

<script>

import Operateur from "@/js/models/Operateur";
import Cleave from 'vue-cleave';
import Detenteur from '../../js/models/Detenteur';

require('cleave.js/dist/addons/cleave-phone.fr');

export default {
    data() {
        return {
            typeUser: localStorage.getItem('typeUser'),
            siret: '',
            detenteur: {},
            siretOpt: {
                blocks: [3, 3, 3, 5],
                delimiter: ' ',
                numericOnly: true,
            },
            cpOpt: {
                blocks: [2, 3, 20],
                delimiter: ' ',
                numericOnly: false
            },
            telOpt: {
                phone: true,
                phoneRegionCode: 'fr'
            },
            canEditDetenteurs: null,
            havOptionCustom: false
        }
    },
    methods: {
        fetchDetenteur() {
            let idDet = this.$route.params.id;
            let vueInstance = this;

            Detenteur
                .getDetenteur(idDet)
                .then(det => {
                    vueInstance.detenteur = det;
                    vueInstance.$refs.cp.cleave.element.value = det.code_postal;

                    if (det.siret) {
                        vueInstance.$refs.siret.cleave.element.value = det.siret
                    }

                    if (det.telephone) {
                        vueInstance.$refs.telephone.cleave.element.value = det.telephone
                    }

                    if (det.portable) {
                        vueInstance.$refs.portable.cleave.element.value = det.portable
                    }

                    if (det.direct) {
                        vueInstance.$refs.lignedirecte.cleave.element.value = det.direct
                    }
                })
        },
        async getPosition() {
            if (this.detenteur.lat && this.detenteur.lng) {
                // swal v6 réutilise la modale ouverte pour l'appel suivant : le bouton ajouté doit être retiré avant.
                const deleteButton = document.createElement('button');
                deleteButton.type = 'button';
                deleteButton.className = 'swal2-styled swal2-delete';
                deleteButton.textContent = 'Supprimer';
                const removeDeleteButton = () => {
                    if (deleteButton.parentNode) {
                        deleteButton.parentNode.removeChild(deleteButton);
                    }
                };
                deleteButton.addEventListener('click', () => {
                    removeDeleteButton();
                    swal.close();
                    this.deletePosition();
                });

                swal({
                    title: "Enregistrer la localisation",
                    text: "Position du détenteur déjà définie, voulez vous la modifier ?",
                    type: "question",
                    confirmButtonText: "Enregistrer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true,
                    onBeforeOpen: (modal) => {
                        const cancelButton = modal.querySelector('.swal2-cancel');
                        cancelButton.parentNode.insertBefore(deleteButton, cancelButton);
                    }
                }).then(async (result) => {
                    removeDeleteButton();
                    if (result == true) {
                        await this.askPosition();
                    }
                }, removeDeleteButton);
            } else {
                await this.askPosition();
            }
        },
        deletePosition() {
            this.detenteur.lat = null;
            this.detenteur.lng = null;
            this.saveDetenteur(false);
        },
        async askPosition() {
            swal({
                title: "Enregistrer la localisation",
                text: "Voulez vous positionner le détenteur à votre position ?",
                type: "question",
                confirmButtonText: "Oui",
                cancelButtonText: "Non",
                showCancelButton: true,
            }).then(async (res) => {
                if (res == true) {
                    if (window.isMobile()) {
                        if (typeof window.flutter_inappwebview !== 'undefined' && window.flutter_inappwebview !== null) {
                            let result = await window.flutter_inappwebview.callHandler('requestGeolocation');

                            if (result !== false) {
                                this.detenteur.lat = result.latitude;
                                this.detenteur.lng = result.longitude;

                                this.saveDetenteur();
                            } else {
                                swal({
                                    title: "Erreur",
                                    text: "La position du détenteur n'a pas été enregistrée.",
                                    type: "error",
                                });
                            }
                        }
                    }
                }
            });
        },
        sendForm() {
            let newDet = this.$data.detenteur;

            let errors = [];
            let txt = '';

            if (newDet.raison_sociale === "") {
                errors.push('la raison sociale / Nom')
            }
            if (newDet.adresse === "") {
                errors.push("l'adresse")
            }
            if (newDet.ville === "") {
                errors.push('la ville')
            }
            if (newDet.code_postal === "") {
                errors.push('le code postal')
            }

            if (errors.length !== 0) {
                txt += 'Veuillez renseigner ';
                txt += errors.join(', ')
            }

            if (newDet.siret) {
                if ((newDet.siret.length !== 17 && newDet.siret.length !== 14) && newDet.siret.length !== 0) {
                    txt += '<br/>SIRET invalide (14 chiffres)'
                }
            }

            if (txt !== '') {
                swal('Information(s) manquante(s) :', txt, 'error')
            } else {
                this.saveDetenteur(true);
            }
        },
        saveDetenteur(goToList = false) {
            let newDet = this.$data.detenteur;

            delete newDet.cpOpt;
            delete newDet.siretOpt;
            delete newDet.telOpt;

            Detenteur.updateDetenteur(newDet).then(() => {
                if (goToList) {
                    let router = this.$router;
                    router.push({ name: 'liste-detenteurs' });
                }
                swal('Détenteur modifié', 'Le détenteur a bien été modifié', 'success')
            })
        }
    },
    mounted: async function () {
        this.canEditDetenteurs = JSON.parse(localStorage.getItem('canEditDetenteurs'));
        this.fetchDetenteur()

        let options = await Operateur.getOperateurOptions();
        options.includes("customIdDetenteur") ? this.haveOption = true : this.haveOption = false;
    },
    components: {
        Cleave
    }
}
</script>

<style>
form#detenteur h2 {
    text-transform: uppercase;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
}

.get-position {
    margin-left: auto;
    margin-top: 20px;
    margin-right: 10px;
    height: 40px;
    width: 50px;
    font-size: 3rem;
    padding-left: 4.5px;
}
</style>



// WEBPACK FOOTER //
// Detenteur.vue?a29b82ce